import React from "react";
import AlvComponentModel from 'components/Models/AlvComponent/AlvComponent';
import cn from 'classnames';
import PropTypes from 'prop-types';
import "./AlvStockPrice.scss";

const AlvStockPrice = ({ language, className }) => {
    return (
        <div className={cn("alv-stock-price", className)}>
            <investor-stock-price lang={language}></investor-stock-price>
        </div>
    );
};

AlvStockPrice.propTypes = Object.assign({}, AlvComponentModel.propTypes, {
    className: PropTypes.string,
});

export default AlvStockPrice;


// WEBPACK FOOTER //
// ./src/components/AlvStockPrice/AlvStockPrice.jsx